import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { Subsidiary } from 'features/Welcome/HotelSwitcher/Subsidiary'
import moment from 'moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import pmsApi from 'services/api/pms'

import styles from './MoveDialog.module.scss'

export const pmsSourceNames = {
  Api: 'API integration',
  Manual: 'Manual upload',
  Ui: 'User interface'
}

function MoveLogsDialog({ onClose, logs, selectedRows, month, year, getLogs }) {
  const history = useHistory()
  const allLogs = logs.flatMap(entry => entry.logs.flatMap(log => log.logs))
  const selectedLogs = allLogs.filter(log => selectedRows.includes(log.id))
  const subsidiaryList = useSelector(s => s.login.subsidiaryList)
  const currentHotel = useSelector(s => s.hotelDetails)
  const [selectedHotel, setSelectedHotel] = useState()
  const [searchParam, setSearchParam] = useState('')

  const isAllLogsSameEmail = selectedLogs.every(
    (log, _, arr) => log.pmsEmail === arr[0].pmsEmail
  )

  const selectableHotels = subsidiaryList.filter(
    hotel =>
      hotel.subsidiaryId !== currentHotel.subsidiaryId && hotel.pms === currentHotel.pms
  )
  const filteredHotels = selectableHotels.filter(h =>
    (h.subsidiaryName + ' #' + h.displayId).match(new RegExp(searchParam, 'i'))
  )

  const onConfirm = async () => {
    try {
      await pmsApi
        .migrateLogs({
          histories: selectedLogs.map(log => ({
            id: log.id,
            reportKind: log.reportKind
          })),
          targetSubsidiaryId: selectedHotel.subsidiaryId,
          month: month,
          year: year
        })
        .then(() => {
          onClose()
          getLogs()
        })
    } catch (error) {
      console.error(error)
    }
  }

  const moveWithEmailHandler = () => {
    if (isAllLogsSameEmail) {
      history.push('/hotelDetails/' + selectedLogs[0].pmsEmail)
    }
  }

  return (
    <ConfirmationDialog
      hasDangerousAction
      hasCloseButton
      hasConfirmButton={!!selectedHotel}
      negativeMessage={selectedHotel ? 'Cancel' : undefined}
      positiveMessage="Confirm and start the process"
      contentAbove={
        <div className={styles.contentAboveContainer}>
          <i className={styles.warningIcon} />
          <p className={styles.warningText}>
            Pay attention! This process may have severe consequences and cannot be
            reversed.
          </p>
        </div>
      }
      title={selectedHotel ? 'Are you sure?' : `Moving ${selectedLogs.length} records`}
      onClose={onClose}
      onReject={selectedHotel ? () => setSelectedHotel(undefined) : onClose}
      onConfirm={onConfirm}
      contentPadding="0"
    >
      {selectedLogs.map((row, index) => (
        <div key={index} className={styles.row}>
          <div className={styles.uploadedByCol}>
            <i className={styles[row.pmsSource]} />
            {row.pmsSource === 'Email'
              ? row.pmsEmail ?? '-'
              : pmsSourceNames[row.pmsSource]}
          </div>

          <div className={styles.subRow}>
            <div className={styles.iconCol}>
              <i className={styles.calendarIcon} />
              120
            </div>

            <div className={styles.iconCol}>
              <i className={styles.userIcon} />
              80
            </div>
          </div>

          <div className={styles.statusCol}>
            <p className={styles.title}>Received</p>
            <p className={styles.subTitle}>
              {moment(row.uploadedOn).format('MMM DD, hh:mm A')}
            </p>
          </div>
        </div>
      ))}

      {isAllLogsSameEmail && (
        <div className={styles.moveByEmailWrapper}>
          <i className={styles.lampIcon} />
          <div className={styles.col}>
            <p className={styles.title}>
              All these records share the same email. Consider moving email with the logs
            </p>

            <p className={styles.buttonText} onClick={moveWithEmailHandler}>
              Move the email with records
            </p>
          </div>
        </div>
      )}

      {selectedHotel ? (
        <p className={styles.confirmationText}>
          I confirm uploads {mergeStrings(selectedLogs.map(i => '#' + i.id))} to deleted
          from #{currentHotel.displayId} {currentHotel.name} and to be re-uploaded to #
          {selectedHotel.displayId} {selectedHotel.merchantName}{' '}
          {selectedHotel.subsidiaryName}.
        </p>
      ) : (
        <>
          <p className={styles.selectHotelText}>Select a hotel to move</p>

          <div className={styles.hotelSelectorWrapper}>
            <div className="hotel-selector">
              <div className="hotel-selector__filter" style={{ display: 'flex' }}>
                <input
                  type="search"
                  placeholder="Search..."
                  onChange={e => setSearchParam(e.target.value)}
                  value={searchParam}
                />
              </div>

              <ul>
                {filteredHotels.map(hotel => (
                  <Subsidiary
                    key={hotel.subsidiaryId}
                    hotel={hotel}
                    handleSelect={setSelectedHotel}
                  />
                ))}
              </ul>
            </div>
          </div>
        </>
      )}
    </ConfirmationDialog>
  )
}

export default MoveLogsDialog

function mergeStrings(strings) {
  if (strings.length === 0) return ''
  if (strings.length === 1) return strings[0]
  return `${strings.slice(0, -1).join(', ')} and ${strings[strings.length - 1]}`
}
